<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Schedules",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Sessions",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Sessions",
                  active: true,
               },                     
            ],

            video_consultation: [
               { mon: [] },
               { tue: [] },
               { wed: [] },
               { thu: [] },
               { fri: [] },
               { sat: [] },
               { sun: [] },
            ],
            sessions:[],
           
            start: '',
            end: '',
            duration:'',
            set_time:'',
            hour:'',
            minutes:'',
            session_name:'',
            day: null,
            type: '',

          

            errors: {},
            loading: false,

         };
      },
      mounted() {
    
      },
      created() {
         this.fetchSessions();
      },

      methods: {
         setConsultations() {
            var sessions;

            var consultation = [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
            ];     

            var schedules = [];

            // if(type == 'video') {
            sessions = this.video;

            console.log('sessions',sessions);

            // } else if(type == 'home') {
            //    sessions = this.home.sessions;

            // } else if(type == 'clinic') {
            //    sessions = this.clinic.sessions;

            // }


            sessions.forEach(obj => {

               var session = {};
               session.start = obj.start_time;
               session.end = obj.end_time;
               session.session_id = obj.id;
               session.day = obj.day_id;
               session.session_name = obj.session_name;

               var index = parseInt(obj.day_id) - 1;
               consultation[index].day.push(session); 

               var schedule = {};
               schedule.day = obj.day_id;               
               schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('hh:mm A');
               schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('hh:mm A');

               schedules.push(schedule); 

            });

            // if(type == 'video') {
               this.video_consultation = consultation;
               this.video_schedules = schedules;

               console.log('video_consultation',this.video_consultation);
               console.log('video_schedules',this.video_schedules);


            // } else if(type == 'home') {
            //    this.home_consultation = consultation;
            //    this.home_schedules = schedules;

            // } else if(type == 'clinic') {
            //    console.log("hi",schedules);

            //    this.clinic_consultation = consultation;
            //    this.clinic_schedules = schedules;
            // }


         },  

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         fetchSessions() {
            let url = "clinic/doctors/masterSessions?doctor_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.sessions = responseData.sessions;  
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         
         addSession() {
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("start", this.start); 
            formData.append("end", this.end); 
            formData.append("session_name", this.session_name); 
            formData.append("doctor_id", this.$route.params.id); 

            let url = "clinic/doctors/addMasterSession"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                     this.$refs['session-modal'].hide();
                     this.$swal("", response.data.message, "success");
                     this.fetchSessions();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     // console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         confirmSchedule() {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want confirm this session?', {
                  title: 'Add session?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                  this.editschedule =1;
                  this.leave_status ='';
                  this.$refs['session-modal'].hide();
                  this.addSession();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         deleteSession(id) {
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("session_id", id); 
            let url = "clinic/doctors/deleteMasterSession"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                   
                     this.$swal("", response.data.message, "success");
                     this.fetchSessions();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     // console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },
         removeSession(id) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you delete this session?', {
                  title: 'Delete session?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                  this.deleteSession(id);
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         checkSessionData() {
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("start", this.start); 
            formData.append("end", this.end); 
            formData.append("session_name", this.session_name); 
            formData.append("doctor_id", this.$route.params.id); 
            // formData.append("day_id", this.day+1); 

            let url = "clinic/doctors/checkSessionData";
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.confirmSchedule();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     // console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },
         clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.type = '';
            this.duration_id = '';
            this.clinic_id = '';
            this.clinic_name = '';
            this.reserved = 3;
            this.session_name = '';
            this.errors = {};
         },

       

         setClinicName() {
            this.clinic_name = event.target.options[event.target.options.selectedIndex].label;
         },


         // geolocate() {
         //    navigator.geolocation.getCurrentPosition((position) => {
         //       this.clinic_marker.position = {
         //         lat: position.coords.latitude,
         //         lng: position.coords.longitude,
         //       };
         //       this.panToMarker();
     //        });
      //    },

         


         //sets the position of marker when dragged
         homeHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         homePanToMarker() {
            this.$refs.homeMapRef.panTo(this.clinic_marker.position);
            this.$refs.homeMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         homeHandleMapClick(e) {
            this.home_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         homeSetPlace(place) {
            this.home_current_place = place;
            if(this.home_current_place) {
               const marker = {
                  lat: this.home_current_place.geometry.location.lat(),
                  lng: this.home_current_place.geometry.location.lng(),
               };
               this.home_center = marker;
               this.home_marker.position = marker;
               this.home_location = place.formatted_address;
            }
         },
      }
   }
</script>

<style type="text/css">
   .schedules table td {
      padding: 10px;
   }

   .schedules table td .row {
      padding: 0;
   }

</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end me-2"><i class='bx bx-chevrons-left'></i> Back</router-link>

                        <b-button v-b-modal.session-modal variant="primary" class="btn btn-primary float-end me-2">Add</b-button>

                     </div>
                  </div>
                  <!----- top button area ends---->

                 

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th  width="20%">Session Name</th>  
                              <th  width="15%">Start Time</th>  
                              <th  width="15%">End Time</th>
                              <th  width="15%">Options</th>

                           </tr>
                        </thead>
                        <tbody v-if="Boolean(sessions.length)">
                           <tr v-for="(session) in sessions" :key="session.id">
                              <td> {{session.session_name}}</td>                      
                              <td> {{ new Date('1970-01-01T' + session.start_time).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) }}</td>
                              <td> {{ new Date('1970-01-01T' + session.end_time).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) }}</td>
                              <td>
                                 <div class="w-200px">
                                    <b-button  variant="danger" class="btn-sm mb-2 me-2" @click="removeSession(session.id)">Delete</b-button>
                                 </div>
                              </td>
                           </tr>
                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="4" class="text-center">No Sessions found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                    

               </div>
            </div>
         </div>
      </div>

         <!---- modal starts ---->
         <b-modal ref="session-modal" id="session-modal" title="Add Session" hide-footer @hidden="clearSession()">
            <b-form @submit.prevent="checkSessionData()">    

              
               <b-col md="12" class="form-group">
                  <label class="control-label">Start Time<span class="text-danger">*</span></label>
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="start" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.start) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="start" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.start" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
                  </b-input-group>
               </b-col>   

               <b-col md="12" class="form-group">
                  <label class="control-label">End Time<span class="text-danger">*</span></label>
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="end" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.end) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="end" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.end" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-input-group>
               </b-col>
                   

               <b-col md="12" class="form-group">
                  <label class="control-label">Session Name<span class="text-danger">*</span></label>
                  <b-form-input v-model="session_name" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.session_name) }"></b-form-input>
                  <div v-for="(val, index) in errors.session_name" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
               </b-col>

               <b-col md="12">
                  <div class="page-loader" v-if="!loading">
                     <b-button type="submit" class="me-3" variant="primary">OK</b-button>
                     <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
                  </div>
                  <div class="page-loader" v-else>
                     <img src="@/assets/images/preloaderspin.gif"/>
                  </div>
               </b-col>

            </b-form>
         </b-modal>
         <!---- modal ends ----->

   </Layout>
</template>
